import { memo, useMemo } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmFormDocumentCommon } from 'KnmPackage/MainModule/interfaces/IKnmFormDocumentCommon';
import { useKnmDocumentAttachment } from 'KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ResultDecisionsItemContentExtract.module.scss';

interface IResultDecisionsItemContentExtractProps {
  extract?: IKnmFormDocumentCommon;
  attachment?: IKnmFormAttachment;
}

export const ResultDecisionsItemContentExtract = memo(
  ({ extract, attachment }: IResultDecisionsItemContentExtractProps) => {
    const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();

    const document = useMemo(() => {
      let attach: IKnmFormAttachment | undefined;

      if (extract) {
        if (extract.attachments?.length === 0) return null;

        attach = extract.attachments?.[0];
      } else {
        attach = attachment;
      }

      return attach || null;
    }, [extract, attachment]);

    const downloadAttachment = () => {
      if (!document) return null;

      const { fileName, fileSize } = document;
      const filePath = document.filePath || null;
      const mimeType = document.mimeType || null;

      downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
    };

    return (
      <div className={styles.Wrapper}>
        <FieldBlock label={'Выписка'}>
          <div className={styles.ActDocument}>
            <div className={styles.InfoBlock}>
              {document && (
                <FieldBlock
                  label={'Файл выписки'}
                  color="black"
                  placementLabel="left"
                  type="not-space"
                  className={styles.FieldBlock}
                >
                  <UploadFile
                    fileName={document?.fileName || ''}
                    fileSize={document?.fileSize || 0}
                    onFileNameClick={downloadAttachment}
                  />
                </FieldBlock>
              )}
              {!extract && !attachment && <Hint text="Формируется автоматически после подписания решения" />}
            </div>
          </div>
        </FieldBlock>
      </div>
    );
  },
);
